import {AppSelectItems} from './app.select.items';
/**
 * SelectItem
 */
export class AppElementSelectItem {
    constructor(){
        this.selectItem = new Array<AppSelectItems>();
    }
/**
     * xml名称,或者表/视图名称
     */
    gridViewConfigName: string;
    /**
     * 默认选中的值，其对应SelectItem元素下Value属性值
     */
    defaultval: string;
    /**
     * 是否展示
     */
    showTab: boolean;
    /**
     * 是否多选
     */
    multiple: boolean;
    /**
     * Select列表数据是来源于后端数据还是页面静态数据，如果来源于后端数据，则为True，
     * 否则为False，当此属性为True时，gridViewConfigName属性才有意义
     */
    isServerData: boolean;
    /**
     * 动态加载数据的api地址,如果此处配置不为空则请求地址以这个为主，反之以telmp 的dataApiUrl如果不为空，
     * 以temp dataApiUrl为主，如果都为空，则使用默认api地址,此处采用就近原则
     */
    dataApiUrl: string;
    /**
     * 分组集合
     */
    selectItem: Array<AppSelectItems>;
    /**
     * 在没有查询到数据时给出的提示
     */
    noDataText: string;
    /**
     * 表格等是否显示头部
     */
    showHead: boolean;
}